import {QuotePDFBuilder} from "./QuotePDFBuilder";
import {QuotePriceLine, QuotePriceRider} from "../../../../../api/QuotePricing";
import {PriceLine, PriceRider} from "../../../../../api/Pricing";
import {PriceSectionNote} from "../../../../../api/PriceSectionNotes";

export function addHardwareSection(bld: QuotePDFBuilder, props: {
    title: string;
    prices: (PriceLine|QuotePriceLine)[];
    riders: (PriceRider|QuotePriceRider)[];
    notes: PriceSectionNote[]
}) {
    const hardware = props.prices.filter(v => v.productType === "hardware");
    const hardwareRiders = props.riders.filter(v => v.productType === "hardware");
    bld.addSection(
        {
            title: props.title,
            note: props.notes.map(v => v.note),
            categories: [
                {
                    name: "Hardware",
                    filter: (i: PriceLine | QuotePriceLine) => i.productType === "hardware",
                    filterRider: (i: PriceRider | QuotePriceRider) => i.productType === "hardware",
                    adminExcludeRiders: true,
                }, !bld.excludeRiders && {
                    name: "Hardware Riders",
                    filter: () => false,
                    filterRider: (i: PriceRider | QuotePriceRider) => i.productType === "hardware",
                }
            ],
        }, hardware as QuotePriceLine[] | PriceLine[], hardwareRiders)
}